var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"h-full w-full overflowDefinition"},[_c('employee-reports',{attrs:{"venueId":_vm.meetingInstance.venueId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }